// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import { getXngCommon } from "@plumberssupply/App/Store/Selectors/CommonSelectors";
import * as React from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps;

export interface ViewRelatedProductsStyles {
    link?: LinkPresentationProps;
}

export const viewRelatedProductsStyles: ViewRelatedProductsStyles = {
    link: {
        css: css`
            visibility: hidden;
            position: absolute;
            margin-top: 12px;
        `,
        typographyProps: {
            size: 14,
            lineHeight: "22px",
        },
    },
};

const styles = viewRelatedProductsStyles;

const ViewRelatedProducts: React.FC<OwnProps> = () => {
    const isMobileScreen = useAppSelector(state => getXngCommon(state).isMobileScreen);
    const isTabletScreen = useAppSelector(state => getXngCommon(state).isTabletScreen);

    const onClick = () => {
        const relatedProductsCarousel = document.querySelector(
            "#productCarousel_customersAlsoPurchased",
        ) as HTMLElement | null;

        relatedProductsCarousel &&
            window.scrollTo({
                top: relatedProductsCarousel?.offsetTop + (isMobileScreen ? 30 : isTabletScreen ? -82 : -112),
                left: 0,
                behavior: "smooth",
            });
    };

    /**
     * Set link visible in ProductCarousel
     */
    return (
        <Link
            data-test-selector="productDetails_viewRelatedProducts"
            id="productDetails_viewRelatedProducts"
            {...styles.link}
            onClick={onClick}
        >
            {translate("View Related Products")}
        </Link>
    );
};

const widgetModule: WidgetModule = {
    component: ViewRelatedProducts,
    definition: {
        displayName: "View Related Products",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
